import { render, staticRenderFns } from "./AmendmentsTab.vue?vue&type=template&id=cbdd7cce&"
import script from "./AmendmentsTab.vue?vue&type=script&lang=ts&"
export * from "./AmendmentsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports